import {
  HStack,
  Box,
  Image,
  Text,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Avatar,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { color } from "../../utils/theme";
import { title } from "../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducer/rootReducer";
import { useNavigate } from "react-router-dom";
import { signOutUser } from "../../redux/action/userAction";
import TrialMode from "../TrialMode";
import { Bell } from "../bell";
export default function Header() {
  const user = useSelector((state: RootState) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();



  const handleSignOut = () => {
    dispatch(signOutUser() as any);
    navigate("/");
  };
  return (
    <VStack w={"100%"} h={"fit-content"} spacing={0}>
      {user.user?.role?.code !== "MOHAD" &&
        user.user?.is_on_trial_period === true && (
          <TrialMode
            createdAt={user.user?.created_at}
            userId={user.user.id}
            isAccountRequested={
              user.user.approval_requests.length !== 0 &&
              user.user.approval_requests[0].status === "Pending"
                ? true
                : false
            }
          />
        )}
      <HStack
        width={"100%"}
        height={"fit-content"}
        shadow={"sm"}
        py={4}
        justifyContent={"space-between"}
        alignItems={"center"}
        alignContent={"center"}
        borderColor={"gray.300"}
        px={5}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            cursor: "pointer",
          }}
          onClick={() => {
            navigate("/");
          }}
        >
          <Box display={"flex"} flexDirection={"row"}>
            <Image
              width="7%"
              height="auto"
              src={require("../../assets/logo.png")}
            />
            <Text color={color.primary} fontWeight={"semibold"}>
              {title}
            </Text>
          </Box>
          {user.user?.approval_requests[0]?.status === "Confirmed" && (
            <Text pl={"7%"} color={color.primary} fontWeight={"semibold"}>
              {user.user?.facility?.name}
            </Text>
          )}
        </Box>
        <HStack spacing={{ base: "0", md: "6" }}>
          <Bell />
          <Flex alignItems={"center"} mt={2}>
            <Menu>
              <MenuButton
                py={2}
                transition="all 0.3s"
                px={5}
                borderRadius={"md"}
                w={250}
                display={"flex"}
                flexDirection={"row"}
                _focus={{ boxShadow: "none" }}
                _hover={{ bg: color.primary, color: color.secondary }}
                color={color.primary}
              >
                <Text
                  fontWeight={"semibold"}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                    alignItems: "center",
                    fontSize: "12",
                  }}
                >
                  <Avatar
                    name={user?.user?.first_name}
                    size={"sm"}
                    src=""
                    color={"black"}
                    bg={color.teritary}
                  />
                  {user?.user?.email}
                </Text>
              </MenuButton>
              <MenuList
                bg={color.secondary}
                alignContent={"center"}
                justifyContent={"center"}
                w={250}
              >
                <MenuItem>
                  <Text>Facility</Text>
                </MenuItem>
                <MenuItem onClick={() => navigate("user-profile")}>
                  <Text>Profile</Text>
                </MenuItem>
                <MenuItem>
                  <Text>{user?.user?.email}</Text>
                </MenuItem>
                <MenuItem
                  onClick={async () => {
                    handleSignOut();
                    localStorage.removeItem("token");
                  }}
                  fontSize={"14"}
                  fontWeight={"semibold"}
                >
                  <Text
                    style={{
                      gap: "10px",
                      justifyContent: "center",
                      textAlign: "left",
                      width: "100%",
                    }}
                  >
                    Sign out
                  </Text>
                </MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </HStack>
      </HStack>
    </VStack>
  );
}
